import { adminHttpClient } from '../../commons/adminHttpClient'

export const getTemplateurl = (id: string): Promise<string> => {
  return adminHttpClient.post('/IchraDecisionTool/StartProposal/DownloadTemplate', { id: id })
}

export const sendProposalToProspect = (fileName: string, prospectId: string): Promise<any> => {
  return adminHttpClient.put('/IchraDecisionTool/StartProposal/SendProposal', {
    fileName: fileName,
    prospectId: prospectId,
  })
}
